export default "__VITE_ASSET__CEgAwpA1__"